/* AndroonBazar — carousel.js
   Scroll-snap carousel with arrow controls. No library. */
(function () {
  'use strict';
  class ABCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      if (this.prev) this.prev.addEventListener('click', () => this.scrollBy(-1));
      if (this.next) this.next.addEventListener('click', () => this.scrollBy(1));

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }
    scrollBy(dir) {
      const item = this.track.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 16);
      this.track.scrollBy({ left: dir * (item.offsetWidth + gap), behavior: 'smooth' });
    }
    onScroll() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.toggleAttribute('disabled', this.track.scrollLeft <= 2);
      if (this.next) this.next.toggleAttribute('disabled', this.track.scrollLeft >= max);
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.classList.toggle('has-overflow', overflow);
    }
  }
  if (!customElements.get('ab-carousel')) customElements.define('ab-carousel', ABCarousel);
})();
